<template>
  <div class="d-flex steps flex-column">
    <div
      v-for="(item, i) in $t('invoices.add.progressSteps')"
      :key="i"
      :class="isActive(i + 1)"
      class="step"
    >
      <div class="status d-flex align-items-center">
        <div class="icon">
          <span class="number" v-if="isActive(i + 1) !== 'completed'">{{
            item.step
          }}</span>
          <b-icon-check-circle-fill class="design-icon" v-else />
        </div>
        <div class="content">
          <h3>
            {{ $t('invoices.add.step') }} {{ item.step }}
            <span class="d-inline-block d-md-none"
              >{{ $t('invoices.add.of') }}
              {{ $t('invoices.add.progressSteps').length }}</span
            >
          </h3>
          <h4>{{ item.text }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../../../assets/scss/variables';
.steps {
  padding-left: 2rem;
  position: relative;
  &:before {
    content: '';
    border-left: 1px solid $dc-svg;
    height: calc(100% * 0.8);
    display: block;
    position: absolute;
    left: 0;
    top: 8%;
  }
  .step {
    border-radius: 5px;
    box-shadow: 0 2px 5px 0 rgba(black, 0.05);
    border: solid 1px $dc-form-border-color;
    background-color: $white;
    min-width: 15rem;
    padding: 1rem;
    text-transform: uppercase;
    position: relative;
    margin-bottom: 1.5rem;
    &:before {
      content: '';
      position: absolute;
      left: -34px;
      width: 30px;
      border-top: 1px solid #8398af;
      top: 50%;
    }
    .icon {
      margin-right: 1rem;
      .number {
        background: $light-background-color;
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: $dc-svg;
      }
      .design-icon {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $primary;
      }
    }
    h3 {
      font-family: $lato;
      font-size: 0.87rem;
      letter-spacing: 1.2px;
      align-items: center;
      margin-bottom: 0.67rem;
    }
    h4 {
      font-family: $montserrat;
      font-size: 1.2rem;
      font-weight: 600;
      letter-spacing: 1.4px;
      color: black;
    }
    &.completed {
      border-left: 4px solid $primary;
    }
    &.active {
      border-left: 4px solid $secondary;
      .icon {
        .number {
          background: $secondary;
          color: $white;
        }
      }
      h4 {
        font-weight: 600;
        color: black;
      }
    }
    &.disabled {
      border-left: 4px solid transparent;
      h4 {
        font-weight: normal;
      }
    }
  }
}
@include media-breakpoint-down(sm) {
  .steps {
    padding-left: 0;
    &:before {
      display: none;
    }
    .step {
      display: none;
      &:before {
        display: none;
      }
      &.active {
        display: block;
      }
    }
  }
}
</style>

<script>
export default {
  methods: {
    isActive(i) {
      if (this.step === i) {
        return 'active'
      } else if (this.step < i) {
        return 'disabled'
      } else {
        return 'completed'
      }
    }
  },
  props: ['step']
}
</script>
